module.exports = __webpack_public_path__ + "img/85_9.874a79a7.png";